export default __webpack_public_path__ + "locales/si/Profile.json?hash=da478b38ccdd489e247f5e3e657abb72";